import React, { useState, useEffect } from 'react';
import { MessageCircle, X } from 'lucide-react';
import { contactInfo } from '../data/mockData';

const WhatsAppButton = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const shouldBeVisible = window.scrollY > 300;
      setIsVisible(shouldBeVisible);
    };

    window.addEventListener('scroll', handleScroll);
    
    // Show tooltip after 3 seconds
    const tooltipTimer = setTimeout(() => {
      setShowTooltip(true);
    }, 3000);

    // Hide tooltip after 8 seconds
    const hideTimer = setTimeout(() => {
      setShowTooltip(false);
    }, 8000);

    return () => {
      window.removeEventListener('scroll', handleScroll);
      clearTimeout(tooltipTimer);
      clearTimeout(hideTimer);
    };
  }, []); // Empty deps is correct - we only want this to run once on mount

  const handleWhatsAppClick = () => {
    const message = encodeURIComponent('Hola, me gustaría solicitar información sobre sus productos.');
    const whatsappUrl = `https://wa.me/${contactInfo.whatsapp}?text=${message}`;
    window.open(whatsappUrl, '_blank');
  };

  return (
    <>
      {isVisible && (
        <div className="fixed bottom-6 right-6 z-50">
          {/* Tooltip */}
          {showTooltip && (
            <div className="absolute bottom-full right-0 mb-4 animate-in slide-in-from-bottom-5 duration-300">
              <div className="bg-white rounded-lg shadow-xl p-4 max-w-xs relative">
                <button
                  onClick={() => setShowTooltip(false)}
                  className="absolute top-2 right-2 text-gray-400 hover:text-gray-600"
                >
                  <X size={16} />
                </button>
                <p className="text-sm text-gray-700 pr-4">
                  <strong className="text-cmv-green">¿Necesita ayuda?</strong><br />
                  Contacte con nosotros por WhatsApp
                </p>
                <div className="absolute bottom-0 right-6 transform translate-y-1/2 rotate-45 w-3 h-3 bg-white"></div>
              </div>
            </div>
          )}

          {/* WhatsApp Button */}
          <button
            onClick={handleWhatsAppClick}
            className="bg-[#25D366] hover:bg-[#20BA5A] text-white rounded-full p-4 shadow-2xl hover:shadow-3xl transition-all duration-300 hover:scale-110 group relative"
            aria-label="Contactar por WhatsApp"
          >
            <MessageCircle size={28} className="group-hover:rotate-12 transition-transform" />
            
            {/* Pulse animation */}
            <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-75"></span>
          </button>
        </div>
      )}
    </>
  );
};

export default WhatsAppButton;
